import createContext from './utils/createContext';
import translateDOMPositionXY from './utils/translateDOMPositionXY';
import isRTL from './utils/isRTL';
var TableContext = createContext({
  rlt: isRTL(),
  isTree: false,
  hasCustomTreeCol: false,
  translateDOMPositionXY: translateDOMPositionXY
});
export default TableContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/TableContext.js
// module id = 278
// module chunks = 35